module.exports = __webpack_public_path__ + "static/img/tenents.a469aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenents.png
// module id = 3YGo
// module chunks = 0